export const ACCESS_REPORTS = "/api/access_report"
export const ACCESS_REPORT = "/api/access_report/:param"
export const ACCESS_REPORT_RESULTS = "/api/access_report/:param/results"

export const ACCESS_REPORT_ACTIVATE = "/api/access_report/:param/activate"
export const ACCESS_REPORT_DEACTIVATE = "/api/access_report/:param/deactivate"
export const ACCESS_REPORT_DELETE = "/api/access_report/:param/delete"